import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import GlobalStyle from "./GlobalStyle";
import useTheme from "../hooks/useTheme";
import styled from "styled-components";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;

function FullScreenLoader() {
  const { theme } = useTheme();

  return (
    <Root>
      <GlobalStyle />
      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems="center"
        direction="column"
        gap={3}
      >
        <Grid>
          <img
            src="/static/img/logo/horizontal_logo.svg"
            style={{
              maxHeight: "52px",
            }}
          />
        </Grid>
        <Grid>
          <CircularProgress />
        </Grid>
      </Grid>
    </Root>
  );
}

export default FullScreenLoader;
